import type { EventOccurrence } from '../shared/contracts';
import { Temporal } from '@js-temporal/polyfill';

export { eventHasEnded, formatEventRange } from '../shared/date-format';

export function toLocalInput(iso: string, timezone: string) {
  if (!/[zZ]|[+-]\d\d:\d\d$/.test(iso)) return iso.slice(0, 16);
  const date = Temporal.Instant.from(iso).toZonedDateTimeISO(timezone);
  return `${date.year.toString().padStart(4, '0')}-${date.month
    .toString()
    .padStart(2, '0')}-${date.day.toString().padStart(2, '0')}T${date.hour
    .toString()
    .padStart(2, '0')}:${date.minute.toString().padStart(2, '0')}`;
}

export function searchEvents(events: EventOccurrence[], query: string) {
  const needle = query.trim().toLocaleLowerCase();
  if (!needle) return events;
  return events.filter((event) =>
    [
      event.title,
      event.summary,
      event.calendarName,
      event.physicalLocation?.name,
      event.physicalLocation?.address,
    ]
      .filter(Boolean)
      .some((value) => value!.toLocaleLowerCase().includes(needle)),
  );
}

export function safeLink(url: string | undefined) {
  if (!url) return undefined;
  try {
    const parsed = new URL(url, window.location.origin);
    return ['http:', 'https:', 'mailto:'].includes(parsed.protocol) ? parsed.href : undefined;
  } catch {
    return undefined;
  }
}

export function getEventIdFromOccurrence(occurrenceId: string) {
  return occurrenceId.includes(':') ? occurrenceId.split(':')[0] : occurrenceId;
}
